import { UserType } from 'src/types'

export const routerUserRedirects = {
  [UserType.ADMIN]: '/redirect/admin',
  [UserType.BUYER]: `/${UserType.BUYER}`,
  [UserType.SELLER]: `/${UserType.SELLER}`,
  [UserType.UNKNOWN]: '/',
}
